import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AiClerkAvatar from './AiClerkAvatar'
import Lucide from '../home/guide/Lucide'
import './SafetyDocEntry.scss'

/**
 * AI 填表员 · 安全文书入口横条
 *
 * 场景:AI 安全隐患台账表页面,筛选区上方。
 * 痛点(隐患数据已有,后面这些安全文书还要手打?)→ 一键上传模板自动填。
 * 右上角可关闭,仅本次会话生效,下次进入页面重新展示。
 */

type Cat = 'red' | 'purple' | 'blue'

const ROW1: Array<[string, Cat]> = [
  ['整改通知单', 'red'],
  ['整改回复单', 'red'],
  ['安全巡查记录表', 'red'],
  ['安全事故报告', 'red']
]

const ROW2: Array<[string, Cat]> = [
  ['隐患台账汇总', 'purple'],
  ['安全生产月报', 'purple'],
  ['施工单位考核表', 'blue']
]

function Tag({ label, cat }: { label: string; cat: Cat }) {
  return (
    <span className={`safety-doc-entry__tag safety-doc-entry__tag--${cat}`}>
      <i className="safety-doc-entry__dot" />
      {label}
    </span>
  )
}

export default function SafetyDocEntry({
  onUpload
}: {
  onUpload?: () => void
}) {
  const navigate = useNavigate()
  const [visible, setVisible] = useState(true)

  const handleClose = () => setVisible(false)

  if (!visible) {
    return null
  }

  return (
    <div className="safety-doc-entry">
      <button
        type="button"
        className="safety-doc-entry__close"
        onClick={handleClose}
        aria-label="关闭"
      >
        <Lucide name="x" size={15} />
      </button>

      <div className="safety-doc-entry__left">
        <AiClerkAvatar size={42} />
        <div className="safety-doc-entry__text">
          <div className="safety-doc-entry__title">
            隐患数据已有了，后面这些表还要手打？
          </div>
          <div className="safety-doc-entry__sub">
            AI自动将照片和数据填入Excel、Word等格式文档
          </div>
        </div>
      </div>

      <span className="safety-doc-entry__divider" />

      <div className="safety-doc-entry__tags">
        <div className="safety-doc-entry__tag-row">
          {ROW1.map(([label, cat]) => (
            <Tag key={label} label={label} cat={cat} />
          ))}
        </div>
        <div className="safety-doc-entry__tag-row">
          {ROW2.map(([label, cat]) => (
            <Tag key={label} label={label} cat={cat} />
          ))}
          <span className="safety-doc-entry__tag safety-doc-entry__tag--more">
            +5 更多文书
          </span>
        </div>
      </div>

      <div className="safety-doc-entry__right">
        <button
          type="button"
          className="safety-doc-entry__cta"
          onClick={() => {
            if (onUpload) {
              onUpload()
            } else {
              navigate('/ai/clerk?from=safety')
            }
          }}
        >
          <Lucide name="upload" size={16} />
          <span>开始填表</span>
        </button>
      </div>
    </div>
  )
}
